<template>
  <div class="statsBar">
    <button
      v-for="stat in stats"
      :key="stat.key"
      class="statChip"
      :class="[`statChip-${stat.key}`, { active: activeFilter === stat.key }]"
      :title="stat.label"
      @click="emit('filter', activeFilter === stat.key ? null : stat.key)"
    >
      <span class="statValue">{{ fmtNum(stat.value) }}</span>
      <span class="statLabel">{{ stat.label }}</span>
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  activeCount: { type: Number, default: 0 },
  engagedCount: { type: Number, default: 0 },
  timedOutCount: { type: Number, default: 0 },
  disqualifiedCount: { type: Number, default: 0 },
  activeFilter: { type: String, default: null },
})

const emit = defineEmits(['filter'])

const stats = computed(() => [
  { key: 'active', label: 'Active', value: props.activeCount },
  { key: 'engaged', label: 'Engaged', value: props.engagedCount },
  { key: 'timed_out', label: 'Timed Out', value: props.timedOutCount },
  { key: 'disqualified', label: 'Disqualified', value: props.disqualifiedCount },
])

function fmtNum(n) {
  if (n >= 10000) return Math.round(n / 1000) + 'k'
  if (n >= 1000) return (Math.round(n / 100) / 10) + 'k'
  return String(n)
}
</script>

<style scoped>
.statsBar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.statChip {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 8px 14px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface);
  cursor: pointer;
  transition: background 0.1s, border-color 0.1s;
  min-width: 80px;
}

.statChip:hover {
  background: var(--row-hover-bg);
}

.statChip.active {
  border-color: var(--primary);
  background: color-mix(in srgb, var(--primary) 8%, var(--surface));
}

.statValue {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  color: var(--text);
}

.statLabel {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--muted);
  white-space: nowrap;
}

.statChip-active .statValue { color: var(--primary); }
.statChip-active.active .statLabel { color: var(--primary); }

.statChip-engaged .statValue { color: var(--success); }
.statChip-engaged.active { border-color: var(--success); background: color-mix(in srgb, var(--success) 8%, var(--surface)); }
.statChip-engaged.active .statLabel { color: var(--success); }

.statChip-disqualified .statValue { color: var(--danger); }
.statChip-disqualified.active { border-color: var(--danger); background: color-mix(in srgb, var(--danger) 8%, var(--surface)); }
.statChip-disqualified.active .statLabel { color: var(--danger); }

.statChip-timed_out .statValue { color: var(--muted); }
</style>
